var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ReactDOM from 'react-dom';
import React, { useState, useEffect, useCallback } from 'react';
import './UiDialog.css';
var rootElement = document.getElementById('root');
export function useUiDialog() {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var Dialog = useCallback(function (uiDialogProps) { return (React.createElement(UiDialog, __assign({}, uiDialogProps, { isOpen: isOpen, setIsOpen: setIsOpen, onClose: close }))); }, [isOpen]);
    function open() {
        setIsOpen(true);
    }
    function close() {
        setIsOpen(false);
    }
    return {
        open: open,
        close: close,
        Dialog: Dialog,
        isOpen: isOpen,
        extendToggle: function (toggle) { return React.cloneElement(toggle, { onClick: open }); },
    };
}
export function UiDialog(_a) {
    var toggle = _a.toggle, children = _a.children, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, onClose = _a.onClose;
    var _b = useState(), element = _b[0], setElement = _b[1];
    useEffect(function () {
        var element = document.createElement('div');
        setElement(element);
        rootElement === null || rootElement === void 0 ? void 0 : rootElement.appendChild(element);
        return function () {
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.removeChild(element);
        };
    }, []);
    useEffect(function () {
        if (isOpen) {
            var keyboardListener_1 = function (event) {
                var keyCodeEscape = 27;
                if (event.keyCode === keyCodeEscape) {
                    event.stopPropagation();
                    onClose();
                }
            };
            document.addEventListener('keydown', keyboardListener_1);
            document.documentElement.classList.add('hide-overflow');
            return function () {
                document.removeEventListener('keydown', keyboardListener_1);
                document.documentElement.classList.remove('hide-overflow');
            };
        }
    }, [isOpen]);
    return (React.createElement(React.Fragment, null,
        React.cloneElement(toggle, { onClick: function () { return setIsOpen(true); } }),
        isOpen &&
            element &&
            ReactDOM.createPortal(React.createElement("div", { className: "UiDialog animated fadeIn" },
                React.createElement("div", { className: "overlay", onClick: onClose }),
                React.createElement("div", { className: "content" },
                    React.createElement("div", { className: "inner" }, children))), element)));
}
